import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getIsDefaultPartner, WindowOpen, zenPoint, } from '@zenlayer/portal-utils';
import { Amount, Icon, Modal, Typography } from '@zenlayer/zen-design';
import t from '@zenlayer/zen-intl18';
import { LinkButton } from '../link-button';
export const useInsufficientBalanceModel = () => {
    const [modal] = Modal.useModal();
    const open = (res) => {
        modal.open({
            width: 444,
            closable: true,
            title: t('d8PM7RGR6jrB'),
            content: (_jsxs("div", { children: [_jsxs(Typography, { children: [_jsx("span", { children: res.ret === 0 ? t('Mam5axUzOOjs') : t('s8m6tBgOB4B0') }), "\u00A0", _jsx(Amount, { prefix: zenPoint, value: typeof res.ret === 'number' ? res.ret / 100 : 0 })] }), _jsxs(Typography, { children: [_jsx("div", { children: t('fjwFiRotZ7aF') }), _jsxs("div", { className: "mt-1", children: [_jsx("span", { children: t('cKj2pSA2M4qq') }), getIsDefaultPartner() && (_jsxs(_Fragment, { children: [_jsx("span", { children: t('N0n0ikRyqA2l') }), _jsx(LinkButton, { target: "tab", href: "https://docs.console.zenlayer.com/welcome/pricing/general-pricing-rules#temporary-hold", children: t('4Yi3zRa4IcTJ') }), _jsx("span", { children: t('c36RWrxRzzKS') })] }))] })] })] })),
            cancelButtonText: null,
            okButtonText: t('MMqM1W4tC1Q4'),
            okButtonProps: {
                icon: _jsx(Icon, { type: "general/JumpLink", block: true }),
            },
            onOk: () => {
                new WindowOpen('/account/payment');
                return false;
            },
        });
    };
    return {
        open,
    };
};
